import {createFleet} from "../../lib/api";
import {useLocation, useNavigate} from "react-router-dom";
import {fetchAllPods} from "../../utils/fleetUtils";
import useFleetStore from "../../utils/store";
import BasePodModal from "./BasePodModal";

export default function CreatePodModal({ setShowPodModal, onCreateSuccess, getAllZonesApi }) {
    const { setAllPodData, setSelectedFleet } = useFleetStore();
    const location = useLocation();
    const navigate = useNavigate();

    const onSuccess = async (newFleet) => {
        const allPods = await fetchAllPods(); // ✅ fetch fresh data
        if (allPods) {
            setAllPodData(allPods); // ✅ Set all pods in Zustand
        }
        if (typeof getAllZonesApi === "function") {
            getAllZonesApi();
        }

        setShowPodModal(false);

        if (location.pathname === "/landingpage") {
            setSelectedFleet(newFleet || allPods?.data?.zones?.[0]);
            navigate("/dashboard");
        }

        if (typeof onCreateSuccess === "function") {
            onCreateSuccess(newFleet);
        }
    }

    return <BasePodModal
      apiMethod={createFleet}
      title="Create Zone"
      buttonText="Create Zone"
      hideModal={() => setShowPodModal(false)}
      shouldFocusOnNameField={true}
      onSuccess={onSuccess}/>;
}